import { computed, isRef } from "vue";
import { useSelectedRowsStore } from "@/Stores/selectedRows";

export function useSelectedRows(storeKey) {
    const storeExists = computed(() => !!selectedRowsStore[_storeKey.value]);

    const _storeKey = computed(() =>
        isRef(storeKey) ? storeKey.value : storeKey
    );

    const selectedRowsStore = useSelectedRowsStore();

    const selectAllValue = computed(
        () => selectedRowsStore[_storeKey.value]?.selectAllValue ?? false
    );

    const selectedRows = computed(
        () => selectedRowsStore[_storeKey.value]?.selectedRows ?? {}
    );

    const selection = computed(() => {
        if (!storeExists.value) {
            return [];
        }
        return Object.keys(selectedRows.value).filter(
            (key) => selectedRows.value[key]
        );
    });

    const handleUpdateSelection = (data, id) => {
        if (!storeExists.value) {
            return;
        }

        if (id === "all") {
            const value = selectAllValue.value !== true;
            data.forEach(
                (row) =>
                    (selectedRowsStore[_storeKey.value].selectedRows[row.id] =
                        value)
            );
        } else {
            selectedRowsStore[_storeKey.value].selectedRows[id] = selectedRows
                .value[id]
                ? !selectedRows.value[id]
                : true;
        }

        if (data.every((row) => selectedRows.value[row.id])) {
            selectedRowsStore[_storeKey.value].selectAllValue = true;
        } else if (data.every((row) => !selectedRows.value[row.id])) {
            selectedRowsStore[_storeKey.value].selectAllValue = false;
        } else {
            selectedRowsStore[_storeKey.value].selectAllValue = "indeterminate";
        }
    };

    const handleClearSelection = () => {
        if (!storeExists.value) {
            return;
        }

        selectedRowsStore[_storeKey.value].selectedRows = {};
        selectedRowsStore[_storeKey.value].selectAllValue = false;
    };

    return {
        selectAllValue,
        selectedRows,
        selection,
        handleUpdateSelection,
        handleClearSelection,
    };
}
